module.exports = __webpack_public_path__ + "img/phone.382f6130.png";